<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">

        <!-- <el-col :span="12">
            <el-form-item label="年份" prop="year">
                <el-date-picker v-model="dataForm.year" value-format="yyyy" type="year" placeholder="选择年" size="small"></el-date-picker>
            </el-form-item>
        </el-col> -->
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="车系平台" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="carPlatform" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.carPlatform" placeholder="车系平台" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item></el-descriptions-item>
                <el-descriptions-item label="基础车型" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="baseCarType" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.baseCarType" placeholder="基础车型" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="基础车型描述" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="baseCarTypeDesc" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.baseCarTypeDesc" placeholder="基础车型描述" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP+1" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP1" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop1" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP+2" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP2" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop2" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP+3" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP3" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop3" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP+4" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP4" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop4" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="SOP+5" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="SOP5" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.sop5" :p="0" :min="0"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()" plain :loading="loading">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    queryDimensionById,
    createDimension,
    editDimension,
} from "@/controller/project";
import CtlNumber from '@/views/common/ctl-number'
import {
    setLoading
} from "@/utils/index";
export default {
    data() {
        return {
            loading: false,
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                id: 0,
                year: '',
                carPlatform: "",
                baseCarType: "",
                baseCarTypeDesc: "",
                sop: 0,
                sop1: 0,
                sop2: 0,
                sop3: 0,
                sop4: 0,
                sop5: 0,
                sop6: 0,
                sop7: 0,
                sop8: 0,
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(id, projectId) {
            this.dataForm.id = id || 0;
            this.dataForm.projectId = projectId;
            this.dataForm.sop = 0
            this.dataForm.sop1 = 0
            this.dataForm.sop2 = 0
            this.dataForm.sop3 = 0
            this.dataForm.sop4 = 0
            this.dataForm.sop5 = 0
            this.view.visible = true;
            this.loading = false;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查零件
                    queryDimensionById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let appartmentParams = {
                        id: this.dataForm.id || undefined,
                        projectId: this.dataForm.projectId,
                        carPlatform: this.dataForm.carPlatform,
                        baseCarType: this.dataForm.baseCarType,
                        baseCarTypeDesc: this.dataForm.baseCarTypeDesc,
                        year: this.dataForm.year,
                        sop: this.dataForm.sop,
                        sop1: this.dataForm.sop1,
                        sop2: this.dataForm.sop2,
                        sop3: this.dataForm.sop3,
                        sop4: this.dataForm.sop4,
                        sop5: this.dataForm.sop5
                    };
                    if (this.dataForm.id) {
                        // 更新量纲
                        editDimension(appartmentParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDimensionDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建零件
                        createDimension(appartmentParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDimensionDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width:120px; text-align: right'
        },
        getStyle2() {
            return 'width:339.5px; text-align: center'
        }
    },
};
</script>
